import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { CloseDialogIcon } from "../DialogComponents/CloseDialogIcon";
import { NewLayerTitleWizard } from "./NewLayerTitleWizard";
import { ActionsContainer, HeaderContainer, TitleContainer, TitleText, TitleWizard } from "./styled";

export const NewLayerStepTitle: FC = () => {
  const { t } = useTranslation();

  return (
    <HeaderContainer>
      <TitleContainer>
        <TitleText>{t("newLayer.dialogHeader", { ns: "dialogs" })}</TitleText>
        <TitleWizard>
          <NewLayerTitleWizard />
        </TitleWizard>
      </TitleContainer>
      <ActionsContainer>
        <CloseDialogIcon />
      </ActionsContainer>
    </HeaderContainer>
  );
};
